import React from 'react';
import { useSearchParams } from 'react-router-dom';
import TripRecommendations from '../components/TripRecommendations';

function parsePreferences(searchParams) {
  return {
    tripDuration: searchParams.get('duration') || '',
    groupType: searchParams.get('groupType') || '',
    interests: searchParams.get('interests') ? searchParams.get('interests').split(',') : [],
    email: searchParams.get('email') || ''
  };
}

const TripRecommendationsPage = () => {
  const [searchParams] = useSearchParams();
  const preferences = parsePreferences(searchParams);

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Rutas recomendadas para ti
          </h2>
          <p className="text-gray-600">
            Hemos seleccionado estas rutas basándonos en tus preferencias
          </p>
        </div>
        <div className="max-w-4xl mx-auto">
          <TripRecommendations preferences={preferences} />
        </div>
      </div>
    </div>
  );
};

export default TripRecommendationsPage; 